<rt-dropdown #adminProfileDropdown [width]="DropdownWidth.FullWidth">
  <div layout>
    @if (hasImpactTrackerInsights()) {
      <tlc-impact-tracker-insights-dropdown />
    }

    <div layout layout-vertical>
      <div padding-small>
        <div class="admin">
          <rt-avatar
            [size]="'medium'"
            [shape]="'oval'"
            [type]="avatarThumbUrl() ? 'image' : 'initials'"
            [initials]="initials()"
            [imageSrc]="avatarThumbUrl()"
            context="admin"
            margin-right-medium
          />
          <div class="admin-data">
            <div class="admin--name">{{ fullName() }}</div>
            @if (currentMember()?.hasFullAccess) {
              <div class="admin--role">{{ 'tlc.members.adminBadge' | translate }}</div>
            }
          </div>
        </div>
      </div>
      <tlc-company-verification-infobox />
      <rt-divider />

      @if (currentCompany()) {
        <rt-dropdown-item
          [targetFor]="selectCompanyTemplate"
          [hasChevronRight]="true"
          (click)="onCompanySelectClicked()"
        >
          <rt-avatar
            [type]="'initials'"
            [shape]="'square'"
            [initials]="(currentCompany()?.name)![0]"
            [isColorized]="true"
            class="company-select-avatar"
            prefix
          />
          <rt-truncate margin-left-small-x>{{ currentCompany()?.name! }}</rt-truncate>
        </rt-dropdown-item>
      } @else {
        <rt-dropdown-item
          [targetFor]="selectCompanyTemplate"
          [hasChevronRight]="true"
          (click)="onCompanySelectClicked()"
        >
          <rt-icon prefix name="nav-company" />
          <rt-truncate margin-left-small-x
            >{{ 'tlc.admin_dropdown.unknown_org_label' | translate }}
          </rt-truncate>
        </rt-dropdown-item>
      }

      <rt-dropdown-item (click)="onEditProfileClicked()" [hasDivider]="true">
        <rt-icon prefix name="person" [size]="'medium'" />
        <span margin-left-small-x> {{ 'tlc.admin_dropdown.profile_settings' | translate }}</span>
      </rt-dropdown-item>

      @if (isNativeMobile) {
        <rt-dropdown-item (click)="onPushNotificationsClicked()">
          <rt-icon prefix name="notifications-active" [size]="'medium'" />
          <span margin-left-small-x>{{ 'tlc.admin_dropdown.push_notifications' | translate }}</span>
        </rt-dropdown-item>
      }

      @if (hasAmbassadorProgram()) {
        <rt-dropdown-item href="//recruitee.partnerstack.com" hrefTarget="_blank">
          <rt-icon prefix name="favorite" [size]="'medium'" />
          <span margin-left-small-x>{{ 'app.header.help_grow' | translate }}</span>
        </rt-dropdown-item>
      }

      @if (hasThemeSwitcher()) {
        <rt-dropdown-item [targetFor]="selectThemeTemplate" [hasChevronRight]="true">
          <rt-icon prefix [name]="themeIconRecord[themeName()!]" [size]="'medium'" />
          <div layout layout-align-items-center margin-left-small-x>
            <span
              >{{ 'app.header.appearance.header' | translate }}:
              {{ themeNameRecord[themeName()!] | translate }}
            </span>
          </div>
        </rt-dropdown-item>

        <ng-template #selectThemeTemplate>
          <rt-theme-select-template
            [selectedTheme]="themeName()!"
            (backButtonClick)="adminProfileDropdown.prevTemplate()"
            [themeIconRecord]="themeIconRecord"
            [themeNameRecord]="themeNameRecord"
            (themeChanged)="themeChange.emit($event)"
          />
        </ng-template>
      }

      <rt-dropdown-item (click)="signOut()" [hasDivider]="true">
        <rt-icon prefix name="power-settings-new" [size]="'medium'" />
        <span margin-left-small-x>{{ 'tlc.admin_dropdown.logout' | translate }}</span>
      </rt-dropdown-item>
    </div>
  </div>
</rt-dropdown>

<ng-template #selectCompanyTemplate>
  <tla-company-select-template
    [currentCompany]="currentCompany()"
    [currentMember]="currentMember()"
    [currentUser]="currentUser()!"
    [members]="companies()!"
    (backButtonClick)="adminProfileDropdown.prevTemplate()"
  />
</ng-template>
